import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ScannerResponse } from '../../models/scanner/scanner';

@Injectable({
  providedIn: 'root',
})
export class ScannerService {
  private _apiUrl = environment.apiUrl;

  private _http = inject(HttpClient);
  private _authHeaders = new HttpHeaders({
    Authorization: '',
    'content-type': 'multipart/form-data',
  });

  public getScanners(): Observable<ScannerResponse> {
    const url: string = `${this._apiUrl}/api/scanner/list`;

    return this._http.get<ScannerResponse>(url,
      {
        headers: this._authHeaders,
      }
    );
  }


}